import { render, staticRenderFns } from "./redemption.vue?vue&type=template&id=053cbb09&"
import script from "./redemption.vue?vue&type=script&lang=ts&"
export * from "./redemption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports